import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { theme } from '../styles/theme';

// Modale di modifica delle note di un evento
function NotesModal({ onClose, notes, setNotes, onSave, saving }) {
  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <button onClick={onClose} style={styles.closeButton}>
          <FontAwesomeIcon icon={faTimes} style={styles.closeIcon} />
        </button>
        <h2 style={styles.modalTitle}>Note Evento</h2>
        <textarea
          style={styles.textarea}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Inserisci le note per questo evento..."
          rows={10}
        />
        <button onClick={onSave} style={styles.saveButton} disabled={saving}>
          {saving ? 'Salvataggio...' : 'Salva'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '500px',
    maxWidth: '90%',
    position: 'relative',
    paddingTop: '40px',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  closeIcon: {
    color: 'red',
    fontSize: '16px',
  },
  modalTitle: {
    marginTop: '0px',
    marginBottom: '20px',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  textarea: {
    width: '100%',
    minHeight: '200px',
    padding: '10px',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    fontSize: '16px',
    resize: 'vertical',
    marginBottom: '20px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  saveButton: {
    padding: '10px 20px',
    backgroundColor: theme.colors.brand,
    color: theme.colors.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    width: '100%',
  },
};

export default NotesModal;
